import {routes, request} from "./"

export function updateMonth (commit, month) {
    return request(commit, routes.months.update, month, 'post')
}



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/api/months.js
// module id = 607
// module chunks = 0